module.exports = __webpack_public_path__ + "img/Wp_2072.11fd23b8.png";